import clickEventName from 'utils/DOM/clickEventName'
import { registerSnowplowTriggers } from 'utils/snowplow/events/userClick/registerSnowplowTriggers'

function registerSnowplowListeners() {
  const triggers = [
    {
      element: '.primaryButton.tile__btn.js-track-plan',
      description: 'Quotes - recommended plan selection',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.tiles-compare',
      description: 'Quotes - recommended plan selection',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '#filters-toggle',
      description: 'Quotes - filters',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'global-filters'
    },
    {
      element: '.js-reset-filters',
      description: 'Quotes - filters',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-edit-profile',
      description: 'Quotes - filters',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-multiselect-option',
      description: 'Quotes - filters selection',
      elementTrigger: 'change',
      eventType: 'click'
    },
    {
      element: '.sp-email-this-quote',
      description: 'Quotes - email this quote',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.sp-brochure',
      description: 'Quotes - see brochure',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.plan__btn-primary.paragraph.btn.js-track-plan',
      description: 'Quotes - see view details',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-compare',
      description: 'Quotes - compare plan',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-addon-dental',
      description: 'Quotes - select dental',
      elementTrigger: 'change',
      eventType: 'click'
    },
    {
      element: '.js-modal',
      description: 'Quotes - see dental and vision details',
      elementTrigger: clickEventName,
      eventType: 'click'
    },

    {
      element: '.js-modal-latitude',
      description: 'Quotes - see latitude details',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-addon-latitude',
      description: 'Quotes - select latitude',
      elementTrigger: 'change',
      eventType: 'click'
    },
    {
      element: '.js-vision-input',
      description: 'Quotes - select vision',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.dental-brochure',
      description: 'Quotes - view dental and vision brochure',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.find-a-dentist',
      description: 'Quotes - find a dentist',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.vision-providers',
      description: 'Quotes - vision providers',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.latitude-brochure',
      description: 'Quotes - view latitude brochure',
      elementTrigger: clickEventName,
      eventType: 'click'
    }
  ]
  registerSnowplowTriggers(triggers)
}

export default registerSnowplowListeners
